import LayoutContext from 'components/Layout/LayoutContext';
import { AuthContext } from 'context/authContext/AuthContext';
import { RegisterContextProvider } from 'context/registerContext/provider';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import {
  getParsedJWTAssessorAccessToken,
  JWTAssessorJson,
} from 'helpers/utils/JWTUtils';
import {
  AssessorCadastroEventoRoutePath,
  AssessorCadastroReuniaoRoutePath,
  AssessorRoutePath,
} from 'library/Routes';
import { ToastTypes } from 'plataforma-fundacao-componentes';
import { useContext } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import Cadastro from './Cadastro';

export default function Wrapper() {
  const location = useLocation();

  const { user } = useContext(AuthContext);
  const { showToast } = useContext(LayoutContext);

  const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
    user!.access_token
  );
  const perfil: IAuthUserPerfil | null = parsedToken
    ? getProfileByJWTRoles(parsedToken.roles)
    : null;

  const match = useRouteMatch<{ id?: string; etapa?: string }>();

  return (
    <RegisterContextProvider>
      <Switch location={location}>
        <Route
          key={'etapas'}
          exact
          path={`${AssessorCadastroEventoRoutePath}:id?/etapas/:etapa?`}
          render={() => {
            if (
              [AuthUserPerfilId.PertencerChat].includes(perfil!?.id!) ||
              ([AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!) &&
                !match.params.id)
            ) {
              setTimeout(() => {
                showToast({
                  pauseOnFocusLoss: true,
                  theme: ToastTypes.Error,
                  showStatusBar: true,
                  timeout: 4000,
                  label: 'Você não possui permissão para acessar está página!',
                });
              }, 1000);
              return <Redirect to={AssessorRoutePath} />;
            } else {
              return <Cadastro reu={false} />;
            }
          }}
        />
        <Route
          key={'reuniao'}
          exact
          path={`${AssessorCadastroReuniaoRoutePath}:id?/etapas/:etapa?`}
          render={() => {
            if (
              [AuthUserPerfilId.PertencerChat].includes(perfil!?.id!)
              // ||
              // ([AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!) &&
              //   !match.params.id)
            ) {
              setTimeout(() => {
                showToast({
                  pauseOnFocusLoss: true,
                  theme: ToastTypes.Error,
                  showStatusBar: true,
                  timeout: 4000,
                  label: 'Você não possui permissão para acessar está página!',
                });
              }, 1000);
              return <Redirect to={AssessorRoutePath} />;
            } else {
              return <Cadastro reu={true} />;
            }
          }}
        />
      </Switch>
    </RegisterContextProvider>
  );
}
